module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-design-2-b770552893e15dd5dfcb6941b48243ef.jpg";